var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagePermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33854 4.16797H2.50521C2.28419 4.16797 2.07223 4.25577 1.91595 4.41205C1.75967 4.56833 1.67188 4.78029 1.67188 5.0013V15.8346C1.67188 16.0556 1.75967 16.2676 1.91595 16.4239C2.07223 16.5802 2.28419 16.668 2.50521 16.668H17.5052C17.7262 16.668 17.9382 16.5802 18.0945 16.4239C18.2507 16.2676 18.3385 16.0556 18.3385 15.8346V14.793",
    stroke: "#A2A4A9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17188 9.58594H7.50521M4.17188 12.9193H14.1719",
    stroke: "#A2A4A9",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1719 9.16797C15.5526 9.16797 16.6719 8.04868 16.6719 6.66797C16.6719 5.28726 15.5526 4.16797 14.1719 4.16797C12.7912 4.16797 11.6719 5.28726 11.6719 6.66797C11.6719 8.04868 12.7912 9.16797 14.1719 9.16797Z",
    stroke: "#A2A4A9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3411 11.8426C17.5274 10.2521 15.8411 9.16797 14.1745 9.16797C12.5078 9.16797 11.6774 9.64005 10.8203 10.418",
    stroke: "#A2A4A9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagePermission);
export default __webpack_public_path__ + "static/media/manage-permission.ed4ede9fa7b5f95bdcb647e9a3eba959.svg";
export { ForwardRef as ReactComponent };